<div class="main-box">
    <div class="left-sub-box">
        <div class="left-sub-container">
            <div *ngIf="hasPostHubAccess" class="post-nav-container">
                <div style="width: 20px; height: 20px; left: 0px;position: absolute">
                    <img src="assets/post-icon.svg">
                </div>
                <div
                    style="width: 5%; height: 30px; left: 245px; position: absolute; transform-origin: 0 0; border: 3px #386AF6 solid">
                </div>
                <div class="left-item-text">Posts Hub
                </div>
            </div>
            <div style="width: 246.13px; height: 0px; border: 0.50px #ECECEC solid"></div>
            <div *ngIf="hasCompetitionZoneAccess" style="width: 172.92px; height: 19.03px; position: relative" routerLink="/admin/social-hub/competition-zone">
                <!-- <div style="width: 3%; height: 30px; left: 245px; position: absolute; transform-origin: 0 0; border: 3px #386AF6 solid"></div> -->
                <div class="left-item-text"> Competitions Hub</div>
                <img src="assets/competition-icon.svg">
            </div>
            <div style="width: 246.13px; height: 0px; border: 0.50px #ECECEC solid"></div>
        </div>
    </div>
    <div fxFlex="60%" style="padding: 10px;">
        <div fxLayout="row" style="gap: 10px">
            <img src="assets/back-icon.svg" style="cursor: pointer;" routerLink="/admin/social-hub/post-hub">
            <span
                style="color: #0E0E0E; font-size: 20px;  font-weight: 600; letter-spacing: 0.04px; word-wrap: break-word">Post
                Details</span>
        </div>
        <div fxLayout="row" style="gap: 40vh;">
            <div fxLayout='column' style="margin-top: 30px;"  *ngIf="!isSchedule">
                <div class="text-style" style="color: #999999; font-size: 11px;">Created at</div>
                <div class="text-style" style="color: #0E0E0E; font-size: 14px; line-height: 18.20px; ">
                    {{postDetails?.created_at | dateTransform : 'std'}} </div>
            </div>
            <div fxLayout='column' style="margin-top: 30px;" *ngIf="isSchedule">
                <div class="text-style" style="color: #999999; font-size: 11px;">Schedule at</div>
                <div class="text-style" style="color: #0E0E0E; font-size: 14px; line-height: 18.20px; ">
                    {{postDetails?.scheduled_time | dateTransform : 'std'}} </div>
            </div>
            <div fxLayout='column' style="margin-top: 30px;" *ngIf="postDetails?.deep_link">
                <div class="text-style" style="color: #999999; font-size: 11px;">Linked to</div>
                <div class="text-style" style="color: #0E0E0E; font-size: 14px; line-height: 18.20px;">
                    {{postDetails?.deep_link?.text}}</div>
            </div>
            <div fxLayout='column' style="margin-top: 30px;" *ngIf="postDetails?.type=='question'">
                <div class="text-style" style="color: #999999; font-size: 11px;">Correct Option</div>
                <div class="text-style" style="color: #0E0E0E; font-size: 14px; line-height: 18.20px;">
                    {{questionCorrectOptionName}}</div>
            </div>
        </div>
        <div style="margin-top: 30px;">
            <div class="text-style" style="text-align: start; color: #999999; font-size: 11px;">Post Text</div>
            <div class="text-style" style="text-align: start; color: #0E0E0E; font-size: 14px; line-height: 18.20px; ">
                <span *ngIf="isReadMore"> {{postDetails?.content.substring(0,120)}} </span>
                <span *ngIf="!isReadMore"> {{postDetails?.content}} </span>

                <span *ngIf="postDetails?.content.length>120 && isReadMore" class="read-more"
                    (click)="isReadMore=false">Read More</span>
            </div>
        </div>
        <ng-container *ngIf="postDetails?.type==='poll' ">
            <div class="vote-section">
                <p class="vote-section-text">Results</p>
                <div class="result-sub-container">
                    <div class ="vote-container" *ngFor="let option of postDetails?.options">
                        <div class="text-container">
                            <span class="result-option">{{ option.text }}</span>
                            <div class="result-slider">
                                <div class="bar" [style.width.%]="calculatePercentage(option.votes,reactionCount)"></div>
                            </div>
                        </div>
                        <div class="result-votes">
                            <span>{{option.votes}}<span style="color: gray; margin-left: 1px; font-size: 11px;">votes</span></span>
                        </div> 
                    </div>
                    <div class="voters-section" *ngIf="pollVoters.length > 0">
                        <div class="voters-display" [ngClass]="{ 'column-layout': showAllVoters, 'row-layout': !showAllVoters }">
                            <div class="voter-item" *ngFor="let voter of displayedVoters.slice(0, showAllVoters ? displayedVoters.length : 5)" [ngClass]="{ 'voter-dot-style': showAllVoters }">
                                {{ voter }}
                            </div>
                            <div class="view-all-btn" *ngIf="!showAllVoters && pollVoters.length > 5" (click)="toggleVotersView()">
                                <span>View All</span>
                            </div>
                        </div>
                        
                        <div class="pagination-container" *ngIf="showAllVoters">
                            <div class="pagination-controls">
                                <button class="pagination-btn" (click)="prevPage()" [disabled]="currentPage === 1">
                                    Previous
                                </button>
                                <span class="page-info">Page {{ currentPage }} of {{ totalPages }}</span>
                                <button class="pagination-btn" (click)="nextPage()" [disabled]="currentPage === totalPages">
                                    Next
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </ng-container>
        <div class="grey-background" *ngIf="!isSchedule">
            <span class="grey-background-heading">Engagement</span>
            <div style="display: flex; gap: 18px;">
                <div class="white-box-in-grey" fxLayout="column">
                    <img style="width: 25%;align-self: center;" src="assets/reaction-icon.svg">
                    <span class="text" *ngIf="postDetails?.type=='text' || postDetails?.type=='images' || postDetails?.type=='video_stream'">Reactions</span>
                    <span class="text" *ngIf="postDetails?.type!='text' && postDetails?.type!='images' && postDetails?.type!='video_stream'">Votes</span>
    
                    <span class="number-value">{{reactionCount}}</span>
                </div>
                <div *ngIf="postDetails.type === 'video_stream' || postDetails.type === 'text' " class="white-box-in-grey" fxLayout="column">
                    <img style="width: 25%; align-self: center;" src="assets/total-play.svg"/>
                    <span class="text">Total Plays</span>
                    <span class="number-value">{{postDetails.view_count}}</span>
                </div>
            </div>
        </div>
        <ng-container *ngIf="postDetails?.type!='poll' && postDetails?.type!='question' ">
            <div class="images-div">
                <p class="reaction-text">Reactions</p>
                <div class="images-container">
                    <div class="div-box" *ngFor="let reaction of postDetails?.reactions | keyvalue;">
                        <p style="font-weight: 500; font-size: 11px; color: gray;">{{ reaction.key }}</p>
                        <span style="font-size: 14px; font-weight: 700;">{{ reaction.value }}</span>
                      </div>
                </div>
            </div>
        </ng-container>
    </div>
    <div fxFlex="30%" style="padding: 30px;">

        <mat-card class="example-card"
            *ngIf="postDetails?.type=='images' || postDetails?.type=='text' || postDetails?.type=='video_stream'">
            <div fxLayout="row" fxLayoutAlign="space-between center">
                <div fxLayout="row" fxLayoutAlign="center" style="gap: 7px;">
                    <img src="assets/swift-chat-logo.svg">
                    <div fxLayout="column">
                        <span class="form-text-label">SwiftChat</span>
                        <span
                            style="color: #999999; font-size: 12px; font-family: Montserrat; font-weight: 500; line-height: 15.60px; word-wrap: break-word">
                            1 day ago</span>
                    </div>
                </div>
                <img src="assets/three-dot.svg">
            </div>
            <mat-card-content style="padding: 10px;margin-bottom: 0px;">
                <span class="content-style"> {{postDetails?.content.substring(0,120)}} </span>
                <span *ngIf="postDetails?.content.length>120" class="read-more">Read More</span>
                <img *ngIf="postDetails?.type=='images'" style="max-height: 200px;" mat-card-image
                    [src]="postDetails?.images[0]" alt="post-photo">
                <div *ngIf="postDetails?.type=='video_stream'" >
                    <img  mat-card-image
                        [src]="postDetails?.thumbnail" alt="post-photo" style="max-height: 200px;">
                </div>
                <div fxLayout="row">
                    <div class="emoji-class">
                        <img src="assets/love-emoji.svg" alt="love-emoji">
                        <span class="text-style" style="color: #999999; font-size: 11px;">Love</span>
                        <div class="partition-line"></div>
                        <img src="assets/like-emoji.svg">
                        <div style="margin-left: -14px;">😍</div>
                        <img style="margin-left: -14px;" src="assets/love-emoji.svg">
                        <span
                            style="color: #282A30; font-size: 11px; font-family: Montserrat; font-weight: 500; line-height: 21px; word-wrap: break-word">79</span>
                    </div>
                    <div fxLayout="row" style=" align-items: center; gap: 5px;">
                        <img src="assets/share.svg">
                        <span class="text-style" style="color: #999999; font-size: 11px;;">Share</span>
                    </div>
                </div>
                <hr>
                <div *ngIf="postDetails?.deep_link"
                    style="text-align: center; color: #386AF6; font-size: 14px; font-family: Montserrat; font-weight: 500; line-height: 18.20px; letter-spacing: 0.20px; word-wrap: break-word">
                    {{ postDetails?.deep_link.text}}</div>
            </mat-card-content>
        </mat-card>


        <mat-card class="example-card"
            *ngIf="postDetails?.type!='images' && postDetails?.type!='text' && postDetails?.type!='video_stream'">
            <div fxLayout="row" fxLayoutAlign="space-between center">
                <div fxLayout="row" fxLayoutAlign="center" style="gap: 7px;">
                    <img src="assets/swift-chat-logo.svg">
                    <div fxLayout="column">
                        <span class="form-text-label">SwiftChat</span>
                        <span
                            style="color: #999999; font-size: 12px; font-family: Montserrat; font-weight: 500; line-height: 15.60px; word-wrap: break-word">
                            1 day ago</span>
                    </div>
                </div>
                <img src="assets/three-dot.svg">
            </div>

            <mat-card-content style="padding: 5px;margin-bottom: 0px;">
                <div class="poll-background">
                    <img *ngIf="postDetails && postDetails.images && postDetails.images.length > 0" style="max-height: 200px; max-width: 100%; margin: 0 auto; display: block; margin-bottom: 13px;" mat-card-image
                    [src]="postDetails?.images[0]" alt="post-photo">
                    <div>
                        <span class="content-style" style="font-size: 16px; font-weight: 600;">
                            {{postDetails?.content.substring(0,120)}} </span>
                        <span *ngIf="postDetails?.content.length>120" class="read-more">Read More</span>
                    </div>
                    <span style="font-weight: 400; font-size: 10px; color: #999999;">Select one</span>


                    <div fxLayout="column">
                        <div style="align-self: stretch; justify-content: flex-start; align-items: flex-start; gap: 8px; display: inline-flex; margin-bottom: 8px;"
                            *ngFor="let option of postDetails?.options; let i= index;">
                            <div
                                style="width: 20px; height: 20px; position: relative; flex-direction: column; justify-content: flex-start; align-items: flex-start; display: inline-flex">
                                <div
                                    style="width: 16px; height: 16px; border-radius: 4px; border: 1.20px #386AF6 solid">
                                </div>
                            </div>
                            <div
                                style="flex: 1 1 0; flex-direction: column; justify-content: flex-start; align-items: flex-start; gap: 12px; display: inline-flex">
                                <div
                                    style="justify-content: flex-start; align-items: center; gap: 45px; display: inline-flex">
                                    <div style="color: black; font-size: 13px; font-family: Montserrat; font-weight: 500; word-wrap: break-word">
                                        {{option.text}}
                                         <div *ngIf="postDetails.type === 'poll' ">
                                             <p *ngIf="option.votes > 1">{{option.votes}} users selected this option</p>
                                             <p  *ngIf="option.votes <= 1">{{option.votes}} user selected this option</p>
                                         </div>
                                    </div>
                                </div>
                                <div style="width: 100%; height: 6px; background: #E1E9FE; border-radius: 8px"></div>
                            </div>
                        </div>
                        <div *ngIf="postDetails?.type!='question'"
                            style="color: #999999; font-size: 11px; font-family: Montserrat; font-weight: 500; line-height: 14.30px; word-wrap: break-word">
                            Last Date - {{postDetails?.expires_at | dateTransform: 'timestamp'}} </div>
                    </div>

                </div>
                <div fxLayout="row" style=" align-items: center; gap: 5px;justify-content: flex-end;">
                    <img src="assets/share.svg">
                    <span class="text-style" style="color: #999999; font-size: 11px;;">Share</span>
                </div>
            </mat-card-content>
        </mat-card>
    </div>
</div>